/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
declare const _UserBoxContainer_settings$ref: unique symbol;
export type UserBoxContainer_settings$ref = typeof _UserBoxContainer_settings$ref;
export type UserBoxContainer_settings = {
    readonly auth: {
        readonly integrations: {
            readonly local: {
                readonly enabled: boolean;
                readonly allowRegistration: boolean;
                readonly targetFilter: {
                    readonly stream: boolean;
                };
            };
            readonly oidc: {
                readonly enabled: boolean;
                readonly allowRegistration: boolean;
                readonly targetFilter: {
                    readonly stream: boolean;
                };
            };
            readonly google: {
                readonly enabled: boolean;
                readonly allowRegistration: boolean;
                readonly targetFilter: {
                    readonly stream: boolean;
                };
            };
            readonly facebook: {
                readonly enabled: boolean;
                readonly allowRegistration: boolean;
                readonly targetFilter: {
                    readonly stream: boolean;
                };
            };
        };
    };
    readonly " $refType": UserBoxContainer_settings$ref;
};



const node: ReaderFragment = (function () {
    var v0 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "enabled",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "allowRegistration",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "targetFilter",
            "storageKey": null,
            "args": null,
            "concreteType": "AuthenticationTargetFilter",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "stream",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Fragment",
        "name": "UserBoxContainer_settings",
        "type": "Settings",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "auth",
                "storageKey": null,
                "args": null,
                "concreteType": "Auth",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "integrations",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "AuthIntegrations",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "local",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "LocalAuthIntegration",
                                "plural": false,
                                "selections": (v0 /*: any*/)
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "oidc",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "OIDCAuthIntegration",
                                "plural": false,
                                "selections": (v0 /*: any*/)
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "google",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "GoogleAuthIntegration",
                                "plural": false,
                                "selections": (v0 /*: any*/)
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "facebook",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "FacebookAuthIntegration",
                                "plural": false,
                                "selections": (v0 /*: any*/)
                            }
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '7dd50485fd42a13dde7f30becc9d7108';
export default node;
